"use strict";
import D from "./index.es100.js";
const { toString: T } = Object.prototype, { getPrototypeOf: w } = Object, { iterator: O, toStringTag: S } = Symbol, g = /* @__PURE__ */ ((t) => (e) => {
  const r = T.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), l = (t) => (t = t.toLowerCase(), (e) => g(e) === t), h = (t) => (e) => typeof e === t, { isArray: p } = Array, f = h("undefined");
function y(t) {
  return t !== null && !f(t) && t.constructor !== null && !f(t.constructor) && a(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const x = l("ArrayBuffer");
function k(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && x(t.buffer), e;
}
const M = h("string"), a = h("function"), P = h("number"), b = (t) => t !== null && typeof t == "object", R = (t) => t === !0 || t === !1, d = (t) => {
  if (g(t) !== "object")
    return !1;
  const e = w(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(S in t) && !(O in t);
}, N = (t) => {
  if (!b(t) || y(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, U = l("Date"), v = l("File"), q = l("Blob"), H = l("FileList"), I = (t) => b(t) && a(t.pipe), K = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || a(t.append) && ((e = g(t)) === "formdata" || // detect form-data instance
  e === "object" && a(t.toString) && t.toString() === "[object FormData]"));
}, V = l("URLSearchParams"), [$, z, J, W] = ["ReadableStream", "Request", "Response", "Headers"].map(l), _ = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function m(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, o;
  if (typeof t != "object" && (t = [t]), p(t))
    for (n = 0, o = t.length; n < o; n++)
      e.call(null, t[n], n, t);
  else {
    if (y(t))
      return;
    const s = r ? Object.getOwnPropertyNames(t) : Object.keys(t), i = s.length;
    let c;
    for (n = 0; n < i; n++)
      c = s[n], e.call(null, t[c], c, t);
  }
}
function B(t, e) {
  if (y(t))
    return null;
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], e === o.toLowerCase())
      return o;
  return null;
}
const u = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, C = (t) => !f(t) && t !== u;
function j() {
  const { caseless: t, skipUndefined: e } = C(this) && this || {}, r = {}, n = (o, s) => {
    const i = t && B(r, s) || s;
    d(r[i]) && d(o) ? r[i] = j(r[i], o) : d(o) ? r[i] = j({}, o) : p(o) ? r[i] = o.slice() : (!e || !f(o)) && (r[i] = o);
  };
  for (let o = 0, s = arguments.length; o < s; o++)
    arguments[o] && m(arguments[o], n);
  return r;
}
const G = (t, e, r, { allOwnKeys: n } = {}) => (m(e, (o, s) => {
  r && a(o) ? t[s] = D(o, r) : t[s] = o;
}, { allOwnKeys: n }), t), Q = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), X = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, Y = (t, e, r, n) => {
  let o, s, i;
  const c = {};
  if (e = e || {}, t == null) return e;
  do {
    for (o = Object.getOwnPropertyNames(t), s = o.length; s-- > 0; )
      i = o[s], (!n || n(i, t, e)) && !c[i] && (e[i] = t[i], c[i] = !0);
    t = r !== !1 && w(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, Z = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, tt = (t) => {
  if (!t) return null;
  if (p(t)) return t;
  let e = t.length;
  if (!P(e)) return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, et = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && w(Uint8Array)), rt = (t, e) => {
  const r = (t && t[O]).call(t);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const o = n.value;
    e.call(t, o[0], o[1]);
  }
}, nt = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, ot = l("HTMLFormElement"), st = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, r, n) {
    return r.toUpperCase() + n;
  }
), A = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), it = l("RegExp"), E = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  m(r, (o, s) => {
    let i;
    (i = e(o, s, t)) !== !1 && (n[s] = i || o);
  }), Object.defineProperties(t, n);
}, at = (t) => {
  E(t, (e, r) => {
    if (a(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (a(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, lt = (t, e) => {
  const r = {}, n = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return p(t) ? n(t) : n(String(t).split(e)), r;
}, ct = () => {
}, ut = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function ft(t) {
  return !!(t && a(t.append) && t[S] === "FormData" && t[O]);
}
const pt = (t) => {
  const e = new Array(10), r = (n, o) => {
    if (b(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (y(n))
        return n;
      if (!("toJSON" in n)) {
        e[o] = n;
        const s = p(n) ? [] : {};
        return m(n, (i, c) => {
          const F = r(i, o + 1);
          !f(F) && (s[c] = F);
        }), e[o] = void 0, s;
      }
    }
    return n;
  };
  return r(t, 0);
}, yt = l("AsyncFunction"), bt = (t) => t && (b(t) || a(t)) && a(t.then) && a(t.catch), L = ((t, e) => t ? setImmediate : e ? ((r, n) => (u.addEventListener("message", ({ source: o, data: s }) => {
  o === u && s === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), u.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  a(u.postMessage)
), mt = typeof queueMicrotask < "u" ? queueMicrotask.bind(u) : typeof process < "u" && process.nextTick || L, dt = (t) => t != null && a(t[O]), gt = {
  isArray: p,
  isArrayBuffer: x,
  isBuffer: y,
  isFormData: K,
  isArrayBufferView: k,
  isString: M,
  isNumber: P,
  isBoolean: R,
  isObject: b,
  isPlainObject: d,
  isEmptyObject: N,
  isReadableStream: $,
  isRequest: z,
  isResponse: J,
  isHeaders: W,
  isUndefined: f,
  isDate: U,
  isFile: v,
  isBlob: q,
  isRegExp: it,
  isFunction: a,
  isStream: I,
  isURLSearchParams: V,
  isTypedArray: et,
  isFileList: H,
  forEach: m,
  merge: j,
  extend: G,
  trim: _,
  stripBOM: Q,
  inherits: X,
  toFlatObject: Y,
  kindOf: g,
  kindOfTest: l,
  endsWith: Z,
  toArray: tt,
  forEachEntry: rt,
  matchAll: nt,
  isHTMLForm: ot,
  hasOwnProperty: A,
  hasOwnProp: A,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: E,
  freezeMethods: at,
  toObjectSet: lt,
  toCamelCase: st,
  noop: ct,
  toFiniteNumber: ut,
  findKey: B,
  global: u,
  isContextDefined: C,
  isSpecCompliantForm: ft,
  toJSONObject: pt,
  isAsyncFn: yt,
  isThenable: bt,
  setImmediate: L,
  asap: mt,
  isIterable: dt
};
export {
  gt as default
};
//# sourceMappingURL=index.es99.js.map
